import React from 'react';
import { ArrowLeftIcon, ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white py-6 px-6" data-id="element-1589">
      <div className="max-w-3xl mx-auto" data-id="element-1590">
        {/* Back button */}
        <div className="mb-12" data-id="element-1591">
          <Link to="/" className="flex items-center text-gray-500 hover:text-[#631bb7] transition-colors" data-id="element-1592">
            <ArrowLeftIcon size={18} className="mr-1.5" data-id="element-1593" />
            <span className="text-sm font-medium" data-id="element-1594">Back</span>
          </Link>
        </div>

        {/* Main content */}
        <div className="flex flex-col items-center text-center" data-id="element-1595">
          {/* Heading */}
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-3 tracking-tight" data-id="element-1596">
            Digital Risk Assessment
          </h1>
          <p className="text-gray-500 text-lg mb-14" data-id="element-1597">
            Get your personalized plan in three to four minutes
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center gap-0 mb-14" data-id="element-1598">
            {/* Step 1: Assess */}
            <div className="flex flex-col items-center" data-id="element-1599">
              <div className="w-16 h-16 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1600">
                <ClipboardCheckIcon size={28} className="text-gray-400" data-id="element-1601" />
              </div>
              <span className="mt-3 text-sm font-semibold text-[#111111]" data-id="element-1602">
                Assess
              </span>
            </div>

            {/* Connector line */}
            <div className="w-12 md:w-20 h-[2px] bg-gray-200 mb-6" data-id="element-1603" />

            {/* Step 2: Inform */}
            <div className="flex flex-col items-center" data-id="element-1604">
              <div className="w-16 h-16 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1605">
                <BookOpenIcon size={28} className="text-gray-400" data-id="element-1606" />
              </div>
              <span className="mt-3 text-sm font-semibold text-[#111111]" data-id="element-1607">
                Inform
              </span>
            </div>

            {/* Connector line */}
            <div className="w-12 md:w-20 h-[2px] bg-gray-200 mb-6" data-id="element-1608" />

            {/* Step 3: Secure */}
            <div className="flex flex-col items-center" data-id="element-1609">
              <div className="w-16 h-16 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1610">
                <ShieldCheckIcon size={28} className="text-gray-400" data-id="element-1611" />
              </div>
              <span className="mt-3 text-sm font-semibold text-[#111111]" data-id="element-1612">
                Secure
              </span>
            </div>
          </div>

          {/* What's Covered */}
          <h2 className="text-lg font-semibold text-[#631bb7] mb-5" data-id="element-1613">
            What's Covered
          </h2>

          <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-1614">
            <div className="flex items-center px-5 py-3 bg-gray-50 rounded-full border border-gray-200" data-id="element-1615">
              <span className="text-lg mr-2.5" data-id="element-1616">🏠</span>
              <span className="text-sm font-medium text-[#111111]" data-id="element-1617">
                Home WiFi & Network
              </span>
            </div>
            <div className="flex items-center px-5 py-3 bg-gray-50 rounded-full border border-gray-200" data-id="element-1618">
              <span className="text-lg mr-2.5" data-id="element-1619">🔐</span>
              <span className="text-sm font-medium text-[#111111]" data-id="element-1620">
                Passwords & Accounts
              </span>
            </div>
            <div className="flex items-center px-5 py-3 bg-gray-50 rounded-full border border-gray-200" data-id="element-1621">
              <span className="text-lg mr-2.5" data-id="element-1622">📱</span>
              <span className="text-sm font-medium text-[#111111]" data-id="element-1623">
                Devices & Apps
              </span>
            </div>
            <div className="flex items-center px-5 py-3 bg-gray-50 rounded-full border border-gray-200" data-id="element-1624">
              <span className="text-lg mr-2.5" data-id="element-1625">🛡️</span>
              <span className="text-sm font-medium text-[#111111]" data-id="element-1626">
                Privacy & Data Protection
              </span>
            </div>
          </div>

          {/* Get Started button */}
          <Link to="/assessment" className="bg-[#631bb7] text-white px-10 py-4 rounded-full font-bold text-base no-underline hover:bg-[#521099] transition-all inline-flex items-center gap-2" data-id="element-1627">
            Get Started
            <ChevronRightIcon size={18} data-id="element-1628" />
          </Link>
        </div>
      </div>
    </div>;
}